import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id BA7E9F56-A5F5-4BEE-8934-90CA070A6029
 * name close-octagon
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/close-octagon.svg
 * tags
 */
export const CloseOctagonIcon = createSvgIcon(<><path d="M8.27,3L3,8.27V15.73L8.27,21H15.73L21,15.73V8.27L15.73,3M8.41,7L12,10.59L15.59,7L17,8.41L13.41,12L17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41" /></>, 'CloseOctagonIcon');
export default CloseOctagonIcon